import { useSelector } from "react-redux";
import { randomInteger } from "@evergis/ui";

import { getPortalConfigSelector, PortalConfiguration } from "../../ducks/portalConfig";

export const useLoginScreenSettings = (): PortalConfiguration["settings"]["loginScreen"] => {
  const config = useSelector(getPortalConfigSelector);
  const { loginScreen } = (config?.settings as PortalConfiguration["settings"]) || {};
  const currentScreen = loginScreen?.[randomInteger(0, loginScreen.length - 1)];

  return {
    ...currentScreen,
    footer: {
      ...currentScreen?.footer,
      logo: currentScreen?.footer?.logo,
    },
    hasContent:
      !!currentScreen?.logo ||
      !!currentScreen?.logoText ||
      !!currentScreen?.title?.text ||
      !!currentScreen?.description?.text ||
      !!currentScreen?.footer?.logo ||
      !!currentScreen?.footer?.networks?.length ||
      !!currentScreen?.footer?.links?.length,
    logoText: {
      ...currentScreen?.logoText,
      text: currentScreen?.logoText?.text,
    },
    title: {
      ...currentScreen?.title,
      text: currentScreen?.title?.text,
    },
    description: {
      ...currentScreen?.description,
      text: currentScreen?.description?.text,
    },
  };
};
